/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { ListEventTypesResponseDto } from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary List active event types for the "Report an event" picker
 */
export const listEventTypesQueryControllerList = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<ListEventTypesResponseDto>({
    url: `/v1/nurseries/${nurseryId}/event-types`,
    method: "GET",
    signal,
  });
};

export const getListEventTypesQueryControllerListQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/event-types`] as const;
};

export const getListEventTypesQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEventTypesQueryControllerListQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEventTypesQueryControllerList>>
  > = ({ signal }) => listEventTypesQueryControllerList(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventTypesQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventTypesQueryControllerList>>
>;
export type ListEventTypesQueryControllerListQueryError = void;

export function useListEventTypesQueryControllerList<
  TData = Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listEventTypesQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEventTypesQueryControllerList<
  TData = Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listEventTypesQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEventTypesQueryControllerList<
  TData = Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List active event types for the "Report an event" picker
 */

export function useListEventTypesQueryControllerList<
  TData = Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventTypesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListEventTypesQueryControllerListQueryOptions(
    nurseryId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
